import { Component, OnInit, ViewChild } from '@angular/core';
import { FacilityDetail, DocumentDetail, ApplicationDetail, PaymentInfoDetail, WarehouseAdditionDraftApplicationModel,
         WarehouseAdditionDraftDetail, Location } from '../../models/ApplicationDetail';
import { UserDto } from '../../models/User';
import { FileUploader } from 'ng2-file-upload';
import { PaymentInfo, ApplicationInfo, ChecklistInstance,
         CheckListValueModel, WarehouseAdditionApplication, FacilityView } from '../../models/ApplicationModel';
import { ApplicationService } from '../../shared/services/application.service';
import { SettingsService } from '../../shared/services/settings.service';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { AccountService } from '../../services/account.service';
import { FacilityService } from '../../shared/services/facility.service';
import { AlertService } from '../../shared/services/alert.service';
import { Router, ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { DocumentRef } from '../../models/DocumentRef';
import { NumberValidator } from '../../validators/number.validator';
import { withNoScriptValidators } from '../../shared/validators/no-script-input.validator';
import {RegionType, WoredaType, ZoneType, BranchOffice, City, Warehouse, FIRItem, SubCityType} from '../../models/CommonModels';
import { CommonService } from '../../shared/services/common.service';
import * as Constants from '../../models/Constants';
import { ChecklistConfigModel } from '../../models/ChecklistModel';
import { environment } from '../../../environments/environment';
import { ErisLoginService } from '../../services/sso/eris-login.service';
import { ErrorHandlerService } from '../../services/error-handler.service';
import { ProfessionalConfigFilter } from '../../models/ProfessionalType';
const URL =  environment.baseUrl + '/Attachment';

@Component({
  selector: 'app-warehouse-addition-application',
  templateUrl: './warehouse-addition-application.component.html',
  styleUrls: ['./warehouse-addition-application.component.css']
})
export class WarehouseAdditionApplicationComponent implements OnInit {

  @ViewChild('otherCity') otherCity;
  public facilities: FacilityView[] = [];
  public tabList: Array < string > = ['facilityInformation', 'warehouseLocation', 'warehouseProfessionals', 'checklists', 'fileAttachments'];
  public tab: string;
  public tabIndex: number;
  public buttonName: string;
  public user: UserDto;
  public uploader: FileUploader;
  public selectedFacilityId: number;
  public selectedFacilityCategoryName: string;
  public selectedFacility: FacilityView = null;
  public selectedFacilityDetail: FacilityDetail;
  private paymentInfo: PaymentInfo = null;
  private allowedFileType = ['pdf'];
  private maxFileSize: number = 6 * 1024 * 1024; // 6 MB
  public draftMode: boolean;
  public documents: Array<DocumentDetail>;
  public documentRefs: Array<DocumentRef>;
  private applicationId: number;
  private draftApplicationId: number;
  public warehouseAdditionForm: FormGroup;
  public warehouseIndex = -1;
  private editMode = false;
  private regionTypes: RegionType[];
  private woredaTypes: WoredaType[];
  private zoneTypes: ZoneType[];
  private subCityTypes: SubCityType[];
  private cities: City[];
  public constants: any = Constants;
  public applicationDetail: ApplicationDetail;
  public editDocuments: Array < DocumentDetail > ;
  public applicationInfo: ApplicationInfo;
  public showErrors = false;
  private checklistItems: Array<ChecklistInstance> = [];
  public checklists: ChecklistConfigModel[];
  public checklistInstances: ChecklistInstance[] = [];
  public noChecklistAvailable = false;
  warehouseAdditionDraft: any;
  warehouses: Warehouse[] = [];
  public restrictedDocRefCount: number;
  public tempCOC = false;
  public professionalTypeConfigList: any[] = [];
  public editableAppId: number;
  showSubCity: boolean;

  constructor(private applicationService: ApplicationService, private settingsService: SettingsService, private fb: FormBuilder,
    private accountService: AccountService, private facilityService: FacilityService, private alertService: AlertService,
    private commonService: CommonService, private router: Router, private route: ActivatedRoute, private spinner: NgxSpinnerService,
    private erisLoginService: ErisLoginService, private errorHandlerService: ErrorHandlerService) {
      this.tempCOC = this.route.snapshot.params['temp'];
      if (this.tempCOC) {
        this.tabList = ['facilityInformation', 'warehouseLocation', 'fileAttachments'];
        this.noChecklistAvailable = true;
      }
      this.applicationId = this.route.snapshot.params['id'];
      this.selectedFacilityId = parseInt(this.route.snapshot.queryParams.facilityId);
      const draftMode = this.route.snapshot.params['draft'];
      this.draftMode = (/true/i).test(draftMode);
      this.getLocationTypes();
     }

  ngOnInit() {
    // initial setup
    this.uploader = new FileUploader({
      url: URL,
      allowedFileType: this.allowedFileType,
      maxFileSize: this.maxFileSize,
      headers: [{
        name: 'Authorization',
        value: 'Bearer ' + this.accountService.getTokenData()
      }]
    });

    if (this.applicationId) {
      this.editMode = true;
      this.getApplicationForEditing();
    }

    this.facilityService.getFacilitiesForWarehouseAddition(this.tempCOC).subscribe(
      res => {
        if (res) {
          this.facilities = this.facilities.concat(res);
          if (this.selectedFacilityId) {
            this.selectedFacility = this.facilities.filter(facility => facility.id === this.selectedFacilityId)[0];
            this.selectedFacilityCategoryName = this.selectedFacility.facilityCategoryName;
            this.facilitySelected();
          }
        } else {
          console.log('Error fetching facilities');
        }
      }, err => {
        console.log('Error fetching facilities ' + err);
        this.alertService.error('Error fetching facilities, ' + this.errorHandlerService.handleApiError(err));
      }
    );

    this.buttonName = 'Next';
    this.tabIndex = 0;
    this.tab = this.tabList[this.tabIndex];
    this.user = this.accountService.getUserData();
    this.documentRefs = [];
    this.documents = [];
    this.initializeForm();
  }

  initializeForm() {
    this.warehouseAdditionForm = this.fb.group({
      location: this.fb.group({
        regionID: [-1, Validators.required],
        zoneID: [-1, Validators.required],
        subCityID: [-1],
        woredaID: [-1, Validators.required],
        cityID: [null],
        kebele: [''],
        houseNo: ['', Validators.required],
        phoneNo: ['', [Validators.required, NumberValidator.isPhoneNumber]],
        areaName: ['', Validators.required]
      }),
      professionals: this.fb.group({}),
      checklist: this.fb.group({}),
      paymentInfo: this.fb.group({
        receiptNumber: ['', withNoScriptValidators([Validators.required])]
      })
    });
  }

  facilitySelected() {
    this.documents = [];
    this.checklistInstances = [];
    this.checklists = [];
    this.selectedFacility = this.facilities.find(fac => fac.id === this.selectedFacilityId);
    if (!this.selectedFacility) {
      return;
    }
    if(!this.selectedFacility.productTypeID && this.applicationDetail){
      this.selectedFacility.productTypeID = this.applicationDetail.productTypeID;
    }

    // Re-seed uploads after clear so Submit validation matches what the UI shows from editDocuments.
    // Without this, a later facilitySelected() (e.g. facilities list load) empties documents while
    // file names/progress still render from editDocuments, leaving Submit disabled.
    if (this.editDocuments && this.editDocuments.length) {
      this.documents = this.editDocuments.map(doc => new DocumentDetail(doc));
    }

    this.fetchDocumentsForWarehouseAddition();
    if(!this.tempCOC){
      this.getCheckListConfig(this.selectedFacility.facilityTypeID, this.selectedFacility.productTypeID, null);
      this.fetchConfiguredProfessionals();
      if(!this.applicationDetail){
        this.applicationService.getApplication(this.selectedFacility.applicationID).subscribe(res => {
          this.applicationDetail = new ApplicationDetail(res, null);
        });
      }
    }
  }

  getLocationTypes() {
    this.commonService.getRegionTypes().subscribe(regionTypes => {
      this.regionTypes = regionTypes;
    });
    this.commonService.getWoredaTypes().subscribe(woredaTypes => {
      this.woredaTypes = woredaTypes;
    });
    this.commonService.getZoneTypes().subscribe(zoneTypes => {
      this.zoneTypes = zoneTypes;
    });
    this.commonService.getCities().subscribe(cities => {
      this.cities = cities;
    });
  }

  repopulateZoneAndWoredaList(regionID: number, zoneID: number, subCityID: number) {

    this.commonService.getZoneTypesByRegion(regionID).subscribe(zoneTypes => {
      this.zoneTypes = zoneTypes;
    });

    if(subCityID){
      this.commonService.getSubCityTypesByZone(zoneID).subscribe(subCityTypes => {
        this.subCityTypes = subCityTypes;
      });
      this.commonService.getWoredaTypesBySubCity(subCityID).subscribe(woredaTypes => {
        this.woredaTypes = woredaTypes;
      });
      this.showSubCity = true;
      this.warehouseAdditionForm.get('location').get('subCityID').setValidators([Validators.required]);
      this.warehouseAdditionForm.get('location').get('subCityID').updateValueAndValidity();
    } else {
      this.commonService.getWoredaTypesByZone(zoneID).subscribe(woredaTypes => {
        this.woredaTypes = woredaTypes;
      });
      this.showSubCity = false;
      this.warehouseAdditionForm.get('location').get('subCityID').clearValidators();
      this.warehouseAdditionForm.get('location').get('subCityID').updateValueAndValidity();
    }
  }

  sortHierarchy = function (adminBoundary, source: string) {
    let selectedBoundaryID = adminBoundary !== null ? adminBoundary.id : -1;
    switch (source) {
      case 'regionID':
        this.commonService.getZoneTypesByRegion(selectedBoundaryID).subscribe(zoneTypes => {
          this.zoneTypes = zoneTypes;
        });
        break;
      case 'zoneID':
        if(adminBoundary.isCity){
          this.commonService.getSubCityTypesByZone(selectedBoundaryID).subscribe(subCityTypes => {
            this.subCityTypes = subCityTypes;
          });
        } else {
          this.commonService.getWoredaTypesByZone(selectedBoundaryID).subscribe(woredaTypes => {
            this.woredaTypes = woredaTypes;
          });
        }
        break;
      case 'subCityID':
        this.commonService.getWoredaTypesBySubCity(selectedBoundaryID).subscribe(woredaTypes => {
          this.woredaTypes = woredaTypes;
        });
        break;
      default:
        break;
    }
  };

  updateHierarchyLists(adminBoundary: any, source: string) {
    if (adminBoundary !== undefined) {
      switch (source) {

        case 'regionID':
          adminBoundary = <RegionType>adminBoundary;
          this.warehouseAdditionForm.controls.location['controls'].zoneID.setValue(null);
          this.warehouseAdditionForm['controls'].location['controls'].woredaID.setValue(null);
          this.sortHierarchy(adminBoundary, source);
          this.woredaTypes = [];
          break;
        case 'zoneID':
          adminBoundary = <ZoneType>adminBoundary;
          this.showSubCity = adminBoundary.isCity ? true : false;
          if(adminBoundary.isCity){         
            this.warehouseAdditionForm.get('location').get('subCityID').setValidators([Validators.required]);      
          } else {
            this.warehouseAdditionForm.get('location').get('subCityID').clearValidators();
          }
          this.warehouseAdditionForm['controls'].location['controls'].woredaID.setValue(null);
          this.warehouseAdditionForm['controls'].location['controls'].subCityID.setValue(null);
          this.warehouseAdditionForm.get('location').get('subCityID').updateValueAndValidity();
          this.sortHierarchy(adminBoundary, source);
          break;
        case 'subCityID':
          adminBoundary = <ZoneType>adminBoundary;
          this.warehouseAdditionForm['controls'].location['controls'].woredaID.setValue(null);
          this.sortHierarchy(adminBoundary, source);
          break;
      }
    }
  }

  getFIRDocumentRefs() {
    if (!this.applicationDetail || !([Constants.FIR_SUBMITTED, Constants.FIR_SUBMITTED_AFTER_INSPECTION].includes(this.applicationDetail.applicationStatusCode))) {
      return undefined;
    }

    let editFields: FIRItem[] = JSON.parse(this.applicationDetail.editedFields);


    let groupIndex = editFields.findIndex(item => item.name === 'Documents');

    if (groupIndex === -1) {
      return new FIRItem();
    } else {
      return editFields[groupIndex];
    }
  }

  getApplicationForEditing() {
    if (this.draftMode) {
      this.draftApplicationId = this.applicationId;
      this.applicationId = null;
      this.applicationService.getDraftApplication(this.draftApplicationId).subscribe(
        res => {
          console.log(res.applicationJsonData);
          const draftApplication: WarehouseAdditionDraftDetail = new WarehouseAdditionDraftDetail(res);
          this.selectedFacilityDetail = draftApplication.facility;
          this.editableAppId = draftApplication.editableApplicationId;
          /*TODO: Assign Temp COC property: may not be necessary*/
          this.intializeEditForm(draftApplication);
          this.setWarehouseApplicationValues(draftApplication, null);
          },
        err => {
          this.alertService.error('Unable to fetch draft application for editing. Please try again later.');
        }
      );
    } else {
      this.applicationService.getApplication(this.applicationId).subscribe(
        res => {
          this.applicationDetail = new ApplicationDetail(res, null);
          if (this.applicationDetail && [Constants.FIR_SUBMITTED, Constants.FIR_SUBMITTED_AFTER_INSPECTION].includes(this.applicationDetail.applicationStatusCode)) {
            if(this.tempCOC){
              this.tabList = ['facilityInformation', 'warehouseLocation', 'fileAttachments'];
            } else {
              this.tabList = ['facilityInformation', 'warehouseLocation', 'warehouseProfessionals', 'fileAttachments'];
            }
          }
          this.editableAppId = this.applicationDetail.id;
          this.selectedFacilityDetail = new ApplicationDetail(res, null).facility;
          this.setWarehouseApplicationValues(this.applicationDetail, (<any>res).applicationInfo);
          this.intializeEditForm(this.applicationDetail);
          },
        err => {
          this.alertService.error('Unable to fetch application for editing. Please try again later.');
        }
      );
    }
  }
  
  intializeEditForm(applicationDetail) {
    let numberOfWarehouses;
    if (applicationDetail && applicationDetail.warehouses) {
      numberOfWarehouses = applicationDetail.warehouses.length;
      this.warehouseIndex = numberOfWarehouses - 1;
      if (this.warehouseIndex >= 0) {
        const newValue = applicationDetail.warehouses[numberOfWarehouses - 1].location;
        this.warehouseAdditionForm.get('paymentInfo').get('receiptNumber').setValue(this.paymentInfo ? this.paymentInfo.recieptNumber : null);

        this.warehouseAdditionForm.get('location').get('regionID').setValue(newValue.regionID);
        this.warehouseAdditionForm.get('location').get('zoneID').setValue(newValue.zoneID);
        this.warehouseAdditionForm.get('location').get('subCityID').setValue(newValue.subCityID);
        this.warehouseAdditionForm.get('location').get('woredaID').setValue(newValue.woredaID);
        this.warehouseAdditionForm.get('location').get('kebele').setValue(newValue.kebele);
        this.warehouseAdditionForm.get('location').get('cityID').setValue(newValue.cityID);
        this.warehouseAdditionForm.get('location').get('houseNo').setValue(newValue.houseNo);
        this.warehouseAdditionForm.get('location').get('phoneNo').setValue(newValue.phoneNo);
        this.warehouseAdditionForm.get('location').get('areaName').setValue(newValue.areaName);
        
        this.repopulateZoneAndWoredaList(newValue.regionID, newValue.zoneID, newValue.subCityID);
      }
    } 
  }

  setWarehouseApplicationValues(application, applicationInfo) {
    this.applicationDetail = application;
    this.applicationInfo = applicationInfo;
    this.facilities = this.facilities.concat(application.facility);
    this.editDocuments = application.documents;
    this.selectedFacility = application.facility;
    this.selectedFacilityId = application.facility.id;
    this.applicationId = application.id;
    const paymentInfo: PaymentInfoDetail = application.paymentInfos ?
      (application.paymentInfos.length ? application.paymentInfos[application.paymentInfos.length - 1] :
        new PaymentInfoDetail({})) : new PaymentInfoDetail({});
    this.paymentInfo = paymentInfo.recieptNumber || paymentInfo.documentID ? new PaymentInfo(paymentInfo) : null;
    this.warehouseAdditionForm.get('paymentInfo').get('receiptNumber').setValue(paymentInfo.recieptNumber || '');
    // Keep receipt control enabled/valid for draft reopen (disabled controls are skipped from parent validity).
    const receiptControl = this.warehouseAdditionForm.get('paymentInfo').get('receiptNumber');
    if (receiptControl.disabled) {
      receiptControl.enable({ emitEvent: false });
    }
    receiptControl.updateValueAndValidity({ emitEvent: false });
    this.facilitySelected();
  }

  fieldHighlighted(controlGroup, controlName) {
    return { 'input-highlight': this.applicationDetail && [Constants.FIR_SUBMITTED, Constants.FIR_SUBMITTED_AFTER_INSPECTION].includes(this.applicationDetail.applicationStatusCode) &&
        !this.inputIsDisabled(null, controlGroup, controlName) };
  }

  inputIsDisabled(inputValue, controlGroup, controlName) {
    if (this.applicationDetail) {
      if (this.applicationDetail.isLegacyData && inputValue) {
        return  !(inputValue.value === null || inputValue.value === '' || inputValue.value === undefined ||
          (inputValue.value['length'] !== undefined && inputValue.value.length === 0)) &&
          !inputValue.dirty;
      } else if ([Constants.FIR_SUBMITTED, Constants.FIR_SUBMITTED_AFTER_INSPECTION].includes(this.applicationDetail.applicationStatusCode)) {
        let editFields: FIRItem[] = JSON.parse(this.applicationDetail.editedFields);

        let groupIndex = editFields.findIndex(item => item.name === controlGroup);

        if (groupIndex === -1) {
          return true;
        }

        return editFields[groupIndex].subItems.findIndex(item => item.name === controlName) === -1;
      }
    }
    return false;
  }

  addOtherCity() {
    let otherCityName = this.otherCity.nativeElement.value;
    if (otherCityName === '') {
      return;
    }
    let existingCity = this.cities.find(c => c.name.trim().toLowerCase() === otherCityName.trim().toLowerCase());
    if (existingCity !== undefined) {
      this.warehouseAdditionForm.get('location').get('cityID').setValue(existingCity.id);
      return;
    }
    const city = new City();
    city.name = otherCityName;
    this.commonService.addCity(city).subscribe(
      resp => {
        this.commonService.getCities().subscribe(
          cities => {
            this.cities = cities;
            let newEltId = this.cities.find(c => c.name === otherCityName).id;
            this.warehouseAdditionForm.get('location').get('cityID').setValue(newEltId);
          });
      });
  }

  tabClicked(tab) {
    this.tab = tab;
    this.tabIndex = this.tabList.indexOf(tab);
    this.setButtonName();
  }

  tabDisabled(tabName) {
    switch (tabName) {
      case 'facilityInformation':
        return !this.warehouseAdditionForm || this.nextButtonsShouldBeDisabled();
      case 'warehouseLocation':
        return !this.warehouseAdditionForm || this.tabDisabled('facilityInformation') || !this.selectedFacilityId;
      case 'warehouseProfessionals':
        return !this.warehouseAdditionForm || this.tabDisabled('warehouseLocation') || this.warehouseAdditionForm.controls.location.invalid;
      case 'checklists':
        return !this.warehouseAdditionForm || this.tabDisabled('warehouseProfessionals') || this.warehouseAdditionForm.controls.professionals.invalid;
      case 'fileAttachments':
        if (this.tabList.length === 2) {
          return !this.warehouseAdditionForm || !this.selectedFacility;
        } else if (this.warehouseAdditionForm && this.tabList.indexOf(tabName) > -1) {
          return !this.warehouseAdditionForm  ||  this.warehouseAdditionForm.controls.location.invalid ||
            (this.checklists.length && (this.tabDisabled('checklists') || this.warehouseAdditionForm.controls.checklist.invalid));
        }
    }
  }

  activeTab(tab) {
    return this.tab === tab;
  }

  nextClicked() {
    if (this.buttonName === 'Submit') {
      this.submitClicked();
    } else {
      this.tabIndex++;
      this.tab = this.tabList[this.tabIndex];
      this.setButtonName();
    }
  }

  buttonsShouldBeDisabled() {
    return !this.selectedFacilityId || !this.selectedFacility;
  }

  nextButtonsShouldBeDisabled() {
    return this.buttonsShouldBeDisabled();
  }

  setButtonName() {
    if (this.tab === 'fileAttachments') {
      this.buttonName = 'Submit';
      //check the check list response and add construction permit letter
      if(!this.tempCOC){
        this.checkConstructionPermitLetterDocumentIsReq();
      }   
    } else {
      this.buttonName = 'Next';
    }
  }

  notFirstTab() {
    return !(this.tabIndex === 0);
  }

  backClicked() {
    this.tab = this.tabList[--this.tabIndex];
    this.setButtonName();
  }

  disableSave() {
    return (!this.selectedFacility);
  }

  disableChecklistButtons() {
    return (this.applicationDetail && [Constants.FIR_SUBMITTED, Constants.FIR_SUBMITTED_AFTER_INSPECTION].includes(this.applicationDetail.applicationStatusCode));

  }

  checkAllRequiredDocsUploaded() {
    if (!this.documentRefs || !this.documentRefs.length) {
      return false;
    }

    // Prefer live documents; fall back to editDocuments when the array was cleared after draft load.
    const uploadedDocs = (this.documents && this.documents.length)
      ? this.documents
      : (this.editDocuments || []);

    // Match file-upload UI: experience letter is only required when smLetterOfExperienceDocRequired is true.
    // Warehouse addition never sets that flag, so the UI hides the asterisk while API still marks required —
    // requiring it here left Submit disabled on fully filled drafts.
    const requiredRefs = this.documentRefs.filter(ref => {
      if (!ref.required) {
        return false;
      }
      if (ref.name === Constants.EXPERIENCE_LETTER_STORE_MANAGER_DOC) {
        return false;
      }
      return true;
    });

    if (!requiredRefs.length) {
      return true;
    }

    return requiredRefs.every(ref => this.isRequiredDocUploaded(ref, uploadedDocs));
  }

  private isRequiredDocUploaded(ref: DocumentRef, uploadedDocs: Array<DocumentDetail | { id?: number; referenceID?: number }>): boolean {
    // Use loose equality — draft JSON / API may mix string and number IDs.
    if (uploadedDocs.some(doc => doc.referenceID == ref.id)) {
      return true;
    }

    // Payment file can appear via paymentInfo.documentID even when referenceID is missing/mismatched.
    if (ref.id == Constants.PAYMENT_REFERENCE_ID && this.paymentInfo && this.paymentInfo.documentID) {
      const paymentDocId = this.paymentInfo.documentID;
      if (uploadedDocs.some(doc => doc.id == paymentDocId)) {
        return true;
      }
      if ((this.editDocuments || []).some(doc => doc.id == paymentDocId)) {
        return true;
      }
    }

    return false;
  }

  createWarehouseObject() {
    this.warehouses = [];
    const existingWarehouse = this.applicationDetail && this.applicationDetail.warehouses && this.warehouseIndex >= 0
      ? this.applicationDetail.warehouses[this.warehouseIndex]
      : null;
    const warehouse = existingWarehouse || new Warehouse();
    const locationId = existingWarehouse && existingWarehouse.location ? existingWarehouse.location.id : null;
    warehouse.location = new Location(this.warehouseAdditionForm.controls.location.value);
    // The location form has no id control, so keep the saved location row when the applicant edits house number.
    if (locationId) {
      warehouse.location.id = locationId;
    }
    this.warehouses.push(warehouse);
  }

  getCheckListConfig(selectedFacilityType, productTypeId, facilityCategoryID) {
    const checklistFormGroup = this.warehouseAdditionForm.get('checklist') as FormGroup;
    // Remove Previous Checklist Controls
    Object.keys(checklistFormGroup.controls).forEach(control => {
      checklistFormGroup.removeControl(control);
    });
    this.settingsService.getChecklistConfigForFacilityTypeProductTypeAppCategoryAndFacilityCategory(
      selectedFacilityType, productTypeId, 6, facilityCategoryID, null).subscribe(
        res => {
          let itemValue;
          if (res.length) {
            this.checklists = res.filter(c => c.active);
            this.checklists.forEach(item => {

              itemValue = this.returnFormValues(item);
              if (item.required) {
                checklistFormGroup.addControl(item.checklist.id.toString(), new FormControl(itemValue, [Validators.required]));
              } else {
                checklistFormGroup.addControl(item.checklist.id.toString(), new FormControl(itemValue));
              }
            });

            this.noChecklistAvailable = !this.checklists.length;

          } else {
            this.noChecklistAvailable = true;
          }
        }
      );
  }

  returnFormValues(item) {
    const checklistFormGroup = this.warehouseAdditionForm.get('checklist') as FormGroup;
    if (this.editMode && this.applicationDetail && this.applicationDetail.checkListItems) {
      const idx = this.applicationDetail.checkListItems.findIndex(it => { return item.checklistID === it.checklistID; });
      if (idx > -1 && this.applicationDetail.checkListItems[idx].checkListValue) {
        return this.applicationDetail.checkListItems[idx].checkListValue.name;
      }
    }
    return checklistFormGroup.get(item.checklist.id.toString()) ? checklistFormGroup.get(item.checklist.id.toString()).value : '';
  }

  fetchDocumentsForWarehouseAddition() {
    this.applicationService.getRequiredDocumentsForWarehouseAddition(this.selectedFacility.facilityTypeID,
      this.selectedFacility.productTypeID, this.tempCOC ? 8 : 6, null).subscribe(
        documents => {
            this.documentRefs = documents;
            const restrictedDocs = this.documentRefs.filter(function (x) {
              return x.required === true;
            });
            this.restrictedDocRefCount = restrictedDocs.length;
        });
  }

  retrievePaymentDetail(detail) {
    this.paymentInfo = detail;
    console.log('payment detail ', detail);
  }

  createChecklistObject() {
    this.checklistInstances = [];
    let controlArray = Object.keys(this.warehouseAdditionForm.get('checklist')['controls']);

    for (let checklistControl of controlArray) {
      if (this.warehouseAdditionForm.get('checklist').get(checklistControl).value.length) {
        const checklistRefIndex = this.checklists.findIndex(item => item.checklist.id.toString() === checklistControl);
        const newChecklistItem: ChecklistInstance = new ChecklistInstance();
        const checklistValue: CheckListValueModel = new CheckListValueModel();
        checklistValue.valueCode = this.warehouseAdditionForm.get('checklist').get(checklistControl).value.toString().toUpperCase();
        checklistValue.name = this.warehouseAdditionForm.get('checklist').get(checklistControl).value.toString();
        newChecklistItem.checkListValue = checklistValue;
        newChecklistItem.checklistID = this.checklists[checklistRefIndex].checklist.id;
        this.checklistInstances.push(newChecklistItem);
      }
    }
  }

  saveWarehouseAddition() {
    this.spinner.show();
    this.createChecklistObject();
    this.createWarehouseObject();
    const configuredProfessions = this.professionalTypeConfigList.map(pc => {
      return pc.professionalType.professionalTypeCode;
    });

    const warehouseAdditionApplicationDraft = new WarehouseAdditionApplication(this.selectedFacilityId,
      this.editableAppId, this.documents,
      this.checklistInstances, this.paymentInfo, this.warehouses, this.selectedFacility, 
      this.warehouseAdditionForm.controls.professionals.value, configuredProfessions);
    
    warehouseAdditionApplicationDraft.productTypeID = this.applicationDetail ? this.applicationDetail.productTypeID : this.selectedFacility.productTypeID;
    warehouseAdditionApplicationDraft.professionals = [this.warehouseAdditionForm.controls.professionals.value];

    this.warehouseAdditionDraft = new WarehouseAdditionDraftApplicationModel(JSON.stringify(warehouseAdditionApplicationDraft),
      this.erisLoginService.getUserId());
    this.warehouseAdditionDraft.applicationCatagoryID = this.tempCOC ? 8 : 6;

    if (this.editMode && this.applicationDetail['draftID']) {
      this.warehouseAdditionDraft['id'] = this.applicationDetail['draftID'];
      this.warehouseAdditionDraft['applicationNumber'] = this.applicationDetail['applicationNumber'];
    }
    this.applicationService.saveDraftApplication(this.warehouseAdditionDraft).subscribe(res => {
      this.spinner.hide();
      if (res) {
        this.alertService.success('Successfully saved warehouse addition application');
        this.router.navigateByUrl('/applications/all');

      } else {
        this.alertService.error('Unable to save draft for application. Please try again later');
      }
    }, error => {
      this.spinner.hide();
    });
  }

  submitClicked() {
    this.spinner.show();
    if (!this.disableChecklistButtons()) {
      this.createChecklistObject();
    } else {
      this.checklistInstances = this.applicationDetail.checkListInstances;
    }
    this.createWarehouseObject();
    const configuredProfessions = this.professionalTypeConfigList.map(pc => {
      return pc.professionalType.professionalTypeCode;
    });
    
    if (this.editMode && (!this.draftMode || this.editableAppId)) {
      this.paymentInfo.applicationID = this.applicationDetail.id;
      this.paymentInfo.id = this.applicationDetail.paymentInfos[0].id;
      const warehouseAdditionApplication: WarehouseAdditionApplication = new WarehouseAdditionApplication(this.selectedFacilityId,
        this.applicationDetail.id, this.documents, this.checklistInstances, this.paymentInfo, this.warehouses, null,
        this.warehouseAdditionForm.controls.professionals.value, configuredProfessions);
      this.applicationService.editWarehouseAdditionApplication(warehouseAdditionApplication, this.tempCOC).subscribe(
        res => {
          this.spinner.hide();
          if (res) {
            this.alertService.success('Successfully edited application');
            const _this = this;
            if (this.draftMode) {
              this.applicationService.deleteDraftApplication(this.draftApplicationId).subscribe( res => {
                console.log('Draft version of the application has been removed');
              }, err => {
                console.log('Unable to remove the draft version of the application');
                this.alertService.error('Unable to remove the draft version of the application');
              });
            }

            setTimeout(() => {
              _this.router.navigateByUrl('/applications/list/' + this.applicationDetail.id);
            }, 1000); 

            
          } else {
            this.alertService.error('Unable to submit application. Please try again later');
          }
        },
        err => {
          this.spinner.hide();
          this.alertService.error('Unable to submit application, ' + this.errorHandlerService.handleApiError(err));
        }
      );

    }else {
      const warehouseAdditionApplication: WarehouseAdditionApplication = new WarehouseAdditionApplication(this.selectedFacilityId,
        null, this.documents, this.checklistInstances, this.paymentInfo, this.warehouses, null, 
        this.warehouseAdditionForm.controls.professionals.value, configuredProfessions);
    this.applicationService.submitApplicationWarehouse(warehouseAdditionApplication, this.tempCOC).subscribe(
      res => {
        this.spinner.hide();
        if (res) {
          this.alertService.success('Successfully submitted application');
          const _this = this;
          if (this.draftMode) {
            this.applicationService.deleteDraftApplication(this.draftApplicationId).subscribe(res => {
              console.log('Draft version of the application has been discarded');
            }, err => {
              console.log('Unable to discard the draft version of the application');
              this.alertService.error('Unable to discard the draft version of the application');
            });
          }

          setTimeout(() => {
            _this.router.navigateByUrl('/applications/list/' + res.id);
          }, 1000);          

        } else {
          this.alertService.error('Unable to submit application. Please try again later');
        }
      },
      err => {
        this.spinner.hide();
        this.alertService.error('Unable to submit application, ' + this.errorHandlerService.handleApiError(err));
      });
    }
  }

  checkConstructionPermitLetterDocumentIsReq(){
    this.checklistItems = [];
    let controlArray = Object.keys(this.warehouseAdditionForm.get('checklist')['controls']);
    const isFacPartiallyCompCheckList = this.checklists != undefined && this.checklists.find(ch => ch.checklist.description === Constants.CHECK_LIST_CONST_PARTIALLY_COMPLETED);
    if(isFacPartiallyCompCheckList && controlArray.findIndex(item => item === isFacPartiallyCompCheckList.checklist.id.toString()) !== -1){         
      if(this.warehouseAdditionForm.get('checklist').get(isFacPartiallyCompCheckList.checklist.id.toString()).value.toString().toUpperCase() === 'YES'){
        if(this.documentRefs.findIndex(dr => dr.name === Constants.CONSTRUCTION_PERMIT_LETTER_DOC.name) === -1){
          this.documentRefs.push(Constants.CONSTRUCTION_PERMIT_LETTER_DOC);
          this.restrictedDocRefCount = this.documentRefs.filter(x => x.required === true).length;
        }
      }else{
        this.removeConstructionPermitDocument();
      }     
    }
  }

  removeConstructionPermitDocument(){
    let index = this.documentRefs.findIndex(dr => dr.name === Constants.CONSTRUCTION_PERMIT_LETTER_DOC.name);
  
    if(index !== -1){
      this.documentRefs.splice(index,1);
      this.restrictedDocRefCount = this.documentRefs.filter(x => x.required === true).length;
    }
  }

  saveNotAllowed(){
    return (this.applicationDetail && this.applicationDetail.applicationCategory && 
      (this.applicationDetail.applicationCategory.applicationCategoryCode === Constants.APPLICATION_TYPE_CODE_ADD_WAREHOUSE ||
      this.applicationDetail.applicationCategory.applicationCategoryCode === Constants.APPLICATION_TYPE_CODE_TEMP_ADD_WAREHOUSE) && 
      [Constants.FIR_SUBMITTED, Constants.FIR_SUBMITTED_AFTER_INSPECTION].includes(this.applicationDetail.applicationStatusCode));
  }

  fetchConfiguredProfessionals() {
    this.professionalTypeConfigList = [];
    const facilityTypeID = (this.selectedFacility && this.selectedFacility.facilityTypeID)
      || (this.applicationDetail && this.applicationDetail.facility && this.applicationDetail.facility.facilityTypeID);
    const productTypeID = (this.selectedFacility && this.selectedFacility.productTypeID)
      || (this.applicationDetail && this.applicationDetail.productTypeID);
    if (!facilityTypeID || !productTypeID) {
      return;
    }
    const professionalConfigFilter = new ProfessionalConfigFilter();
    professionalConfigFilter.applicationCategoryID = this.tempCOC ? 8 : 6;
    professionalConfigFilter.facilityTypeID = facilityTypeID;
    professionalConfigFilter.productTypeID = productTypeID;

    this.settingsService.getProfessionalConfigListForApplicant(professionalConfigFilter).subscribe( res => {
      this.professionalTypeConfigList = res;
      this.createProfessionalForm();
    }, err => {
      this.alertService.error(this.errorHandlerService.handleApiError(err));
    }, () => {

    });
  }


  createProfessionalForm() {
    const professionalsGroup = this.warehouseAdditionForm.get('professionals') as FormGroup;
    // Remove previous controls so a second facilitySelected() (common on draft edit) can rebuild safely.
    Object.keys(professionalsGroup.controls).forEach(key => {
      professionalsGroup.removeControl(key);
    });

    const allProfessionals = this.editMode && this.applicationDetail && this.applicationDetail.professionals
      ? this.applicationDetail.professionals[0]
      : null;

    this.professionalTypeConfigList.forEach(profConfig => {
      profConfig.professionalFieldConfig.filter(pfc => pfc.active).forEach( pf => {
        let fieldValue = allProfessionals
          ? allProfessionals[this.formatControlName(profConfig, pf)]
          : undefined;
        let fieldValueExistsInLookup = true;

        if (allProfessionals && pf.professionalField.professionalFieldCode === Constants.EDUCATION_LEVEL_CODE) {
          fieldValueExistsInLookup = Boolean(profConfig.educationLevelConfig.find(elc => elc.educationLevelID === fieldValue));
        }

        professionalsGroup.addControl(
          this.formatControlName(profConfig, pf),
          new FormControl(allProfessionals
            ? (fieldValueExistsInLookup ? fieldValue : null)
            : undefined, null));

        if (pf.required) {
          professionalsGroup.get(this.formatControlName(profConfig, pf))
            .setValidators(Validators.required);

          if (pf.professionalField.dataType === 'phoneNumber') {
            professionalsGroup.get(this.formatControlName(profConfig, pf))
              .setValidators([NumberValidator.isPhoneNumber, Validators.required]);
          } else if (pf.professionalField.dataType === 'email') {
            professionalsGroup.get(this.formatControlName(profConfig, pf))
              .setValidators([Validators.email, Validators.required]);
          }

          if (pf.professionalField.name === Constants.EXPERIENCE_LABEL) {
            professionalsGroup.get(this.formatControlName(profConfig, pf))
              .setValidators([Validators.min(0), Validators.required]);
          }
        } else {
          if (pf.professionalField.dataType === 'phoneNumber') {
            professionalsGroup.get(this.formatControlName(profConfig, pf))
              .setValidators(NumberValidator.isPhoneNumber);
          } else if (pf.professionalField.dataType === 'email') {
            professionalsGroup.get(this.formatControlName(profConfig, pf))
              .setValidators(Validators.email);
          }

          if (pf.professionalField.name === Constants.EXPERIENCE_LABEL) {
            professionalsGroup.get(this.formatControlName(profConfig, pf))
              .setValidators(Validators.min(0));
          }
        }
      });
    });
  }

  formatControlName(profTypeConfig, field) {
    return profTypeConfig.professionalType.professionalTypeCode.toLowerCase() + field.professionalField.name.replace(/ /g, '')
      + (field.professionalField.dataType === 'lookup' ? 'ID' : '');
  }
}